import { FilterOptions } from '../types/plant-filter.types'

// Wspólne opcje dla formularza i filtrów roślin
export const plantOptions: FilterOptions = {
  // Opcje kategorii
  category: [
    { id: 'iglaste', label: 'Iglaste', count: 0 },
    { id: 'liściaste', label: 'Liściaste', count: 0 },
    { id: 'wrzosowate', label: 'Wrzosowate', count: 0 },
    { id: 'pnącza', label: 'Pnącza', count: 0 },
    { id: 'róże', label: 'Róże', count: 0 },
    { id: 'byliny', label: 'Byliny', count: 0 },
    { id: 'owocowe', label: 'Owocowe', count: 0 }
  ],

  // Opcje koloru kwiatów
  flowerColor: [
    { id: 'zielone', label: 'Zielone', count: 0 },
    { id: 'białe (beżowe, kremowe)', label: 'Białe', count: 0 },
    { id: 'czerwone', label: 'Czerwone', count: 0 },
    { id: 'różowe', label: 'Różowe', count: 0 },
    { id: 'niebieskie', label: 'Niebieskie', count: 0 },
    { id: 'pomarańczowe', label: 'Pomarańczowe', count: 0 },
    { id: 'purpurowe', label: 'Purpurowe', count: 0 },
    { id: 'fioletowe', label: 'Fioletowe', count: 0 },
    { id: 'wielobarwne', label: 'Wielobarwne', count: 0 },
    { id: 'żółte', label: 'Żółte', count: 0 },
    { id: 'lila', label: 'Lila', count: 0 }
  ],

  // Opcje koloru liści
  leafColor: [
    { id: 'zielone', label: 'Zielone', count: 0 },
    { id: 'ciemnozielone', label: 'Ciemnozielone', count: 0 },
    { id: 'jasnozielone', label: 'Jasnozielone', count: 0 },
    { id: 'czerwone i purpurowe', label: 'Czerwone i purpurowe', count: 0 },
    { id: 'szare, niebieskawe, srebrzyste', label: 'Szare, niebieskawe, srebrzyste', count: 0 },
    { id: 'wielobarwne', label: 'Wielobarwne', count: 0 },
    { id: 'pstre lub obrzeżone', label: 'Pstre lub obrzeżone', count: 0 },
    { id: 'żółte', label: 'Żółte', count: 0 },
    { id: 'złociste', label: 'Złociste', count: 0 }
  ],

  // Opcje typu gleby
  soilType: [
    { id: 'przepuszczalne', label: 'Przepuszczalne', count: 0 },
    { id: 'średnio-przepuszczalne', label: 'Średnio-przepuszczalne', count: 0 },
    { id: 'gliniaste', label: 'Gliniaste', count: 0 },
    { id: 'próchnicze', label: 'Próchnicze', count: 0 },
    { id: 'torfowe', label: 'Torfowe', count: 0 }
  ],

  // Opcje nasłonecznienia
  sunExposure: [
    { id: 'pełne słońce', label: 'Pełne słońce', count: 0 },
    { id: 'półcień', label: 'Półcień', count: 0 },
    { id: 'cień', label: 'Cień', count: 0 }
  ],

  // Opcje dla formy rośliny
  form: [
    { id: 'drzewo', label: 'Drzewo', count: 0 },
    { id: 'krzew', label: 'Krzew', count: 0 },
    { id: 'krzewinka', label: 'Krzewinka', count: 0 },
    { id: 'pnącze', label: 'Pnącze', count: 0 },
    { id: 'bylina', label: 'Bylina', count: 0 }
  ],

  // Opcje dla siły wzrostu
  growthRate: [
    { id: 'szybka', label: 'Szybka', count: 0 },
    { id: 'średnia', label: 'Średnia', count: 0 },
    { id: 'wolna', label: 'Wolna', count: 0 }
  ],

  // Opcje dla pokroju
  habit: [
    { id: 'wyprostowany', label: 'Wyprostowany', count: 0 },
    { id: 'krzaczasty', label: 'Krzaczasty', count: 0 },
    { id: 'zwarty', label: 'Zwarty', count: 0 },
    { id: 'rozłożysty', label: 'Rozłożysty', count: 0 },
    { id: 'płożący', label: 'Płożący', count: 0 },
    { id: 'płaczący', label: 'Płaczący', count: 0 },
    { id: 'kolumnowy', label: 'Kolumnowy', count: 0 },
    { id: 'parasolowaty', label: 'Parasolowaty', count: 0 },
    { id: 'stożkowaty', label: 'Stożkowaty', count: 0 },
    { id: 'kulisty', label: 'Kulisty', count: 0 }
  ],

  // Opcje dla typu liści
  leafType: [
    { id: 'zimozielone', label: 'Zimozielone', count: 0 },
    { id: 'sezonowe', label: 'Sezonowe', count: 0 }
  ],

  // Opcje dla miesięcy
  floweringSeason: [
    { id: 'I', label: 'Sty', count: 0 },
    { id: 'II', label: 'Lut', count: 0 },
    { id: 'III', label: 'Mar', count: 0 },
    { id: 'IV', label: 'Kwi', count: 0 },
    { id: 'V', label: 'Maj', count: 0 },
    { id: 'VI', label: 'Cze', count: 0 },
    { id: 'VII', label: 'Lip', count: 0 },
    { id: 'VIII', label: 'Sie', count: 0 },
    { id: 'IX', label: 'Wrz', count: 0 },
    { id: 'X', label: 'Paź', count: 0 },
    { id: 'XI', label: 'Lis', count: 0 },
    { id: 'XII', label: 'Gru', count: 0 }
  ],

  // Opcje dla owoców
  fruits: [
    { id: 'tak', label: 'Tak', count: 0 },
    { id: 'nie', label: 'Nie', count: 0 }
  ],

  // Opcje dla pory owocowania
  fruitingSeason: [
    { id: 'I', label: 'Sty', count: 0 },
    { id: 'II', label: 'Lut', count: 0 },
    { id: 'III', label: 'Mar', count: 0 },
    { id: 'IV', label: 'Kwi', count: 0 },
    { id: 'V', label: 'Maj', count: 0 },
    { id: 'VI', label: 'Cze', count: 0 },
    { id: 'VII', label: 'Lip', count: 0 },
    { id: 'VIII', label: 'Sie', count: 0 },
    { id: 'IX', label: 'Wrz', count: 0 },
    { id: 'X', label: 'Paź', count: 0 },
    { id: 'XI', label: 'Lis', count: 0 },
    { id: 'XII', label: 'Gru', count: 0 }
  ],

  // Opcje dla wilgotności gleby
  soilMoisture: [
    { id: 'suche', label: 'Suche', count: 0 },
    { id: 'umiarkowanie wilgotne', label: 'Umiarkowanie wilgotne', count: 0 },
    { id: 'wilgotne', label: 'Wilgotne', count: 0 }
  ],

  // Opcje dla pH gleby
  soilPh: [
    { id: 'kwaśne', label: 'Kwaśne', count: 0 },
    { id: 'obojętne', label: 'Obojętne', count: 0 },
    { id: 'zasadowe', label: 'Zasadowe', count: 0 }
  ],

  // Opcje dla walorów
  features: [
    { id: 'atrakcyjne kwiaty', label: 'Atrakcyjne kwiaty', count: 0 },
    { id: 'atrakcyjne liście', label: 'Atrakcyjne liście', count: 0 },
    { id: 'atrakcyjne owoce', label: 'Atrakcyjne owoce', count: 0 },
    { id: 'atrakcyjna kora', label: 'Atrakcyjna kora', count: 0 },
    { id: 'pachnące kwiaty', label: 'Pachnące kwiaty', count: 0 },
    { id: 'mrozoodporność', label: 'Mrozoodporność', count: 0 },
    { id: 'odporność na zanieczyszczenia', label: 'Odporność na zanieczyszczenia', count: 0 },
    { id: 'odporność na choroby', label: 'Odporność na choroby', count: 0 },
    { id: 'odporność na suszę', label: 'Odporność na suszę', count: 0 },
    { id: 'tolerancja na zasolenie', label: 'Tolerancja na zasolenie', count: 0 },
    { id: 'miododajność', label: 'Miododajność', count: 0 },
    { id: 'dla ptaków', label: 'Dla ptaków', count: 0 },
    { id: 'dla motyli', label: 'Dla motyli', count: 0 },
    { id: 'roślina lecznicza', label: 'Roślina lecznicza', count: 0 },
    { id: 'jadalne owoce', label: 'Jadalne owoce', count: 0 },
    { id: 'jadalne kwiaty', label: 'Jadalne kwiaty', count: 0 },
    { id: 'przyciągająca zapylacze', label: 'Przyciągająca zapylacze', count: 0 }
  ],

  // Opcje dla rodzajów ogrodów
  gardenTypes: [
    { id: 'naturalistyczny', label: 'Naturalistyczny', count: 0 },
    { id: 'nowoczesny', label: 'Nowoczesny', count: 0 },
    { id: 'formalny', label: 'Formalny', count: 0 },
    { id: 'wiejski', label: 'Wiejski', count: 0 },
    { id: 'nadmorski', label: 'Nadmorski', count: 0 },
    { id: 'skalny', label: 'Skalny', count: 0 },
    { id: 'wrzosowisko', label: 'Wrzosowisko', count: 0 },
    { id: 'japoński', label: 'Japoński', count: 0 },
    { id: 'śródziemnomorski', label: 'Śródziemnomorski', count: 0 },
    { id: 'leśny', label: 'Leśny', count: 0 },
    { id: 'deszczowy', label: 'Deszczowy', count: 0 },
    { id: 'miejski', label: 'Miejski', count: 0 }
  ],

  // Opcje dla zastosowania
  usage: [
    { id: 'zadrzewienia krajobrazowe', label: 'Zadrzewienia krajobrazowe', count: 0 },
    { id: 'drzewo alejowe uliczne', label: 'Drzewo alejowe uliczne', count: 0 },
    { id: 'drzewo alejowe parkowe', label: 'Drzewo alejowe parkowe', count: 0 },
    { id: 'szpaler', label: 'Szpaler', count: 0 },
    { id: 'żywopłot', label: 'Żywopłot', count: 0 },
    { id: 'rabaty', label: 'Rabaty', count: 0 },
    { id: 'donice / pojemniki', label: 'Donice/pojemniki', count: 0 },
    { id: 'kwiaty cięte', label: 'Kwiaty cięte', count: 0 },
    { id: 'suche bukiety', label: 'Suche bukiety', count: 0 },
    { id: 'w grupach', label: 'W grupach', count: 0 },
    { id: 'soliter (pojedynczo)', label: 'Soliter (pojedynczo)', count: 0 },
    { id: 'pnącze na ogrodzenia', label: 'Pnącze na ogrodzenia', count: 0 },
    { id: 'pnącze na pergole / kraty', label: 'Pnącze na pergole/kraty', count: 0 },
    { id: 'pnącze na ściany', label: 'Pnącze na ściany', count: 0 },
    { id: 'balkon / taras', label: 'Balkon/taras', count: 0 },
    { id: 'rekultywacja', label: 'Rekultywacja', count: 0 },
    { id: 'zieleń publiczna', label: 'Zieleń publiczna', count: 0 },
    { id: 'zielone dachy', label: 'Zielone dachy', count: 0 },
    { id: 'roślina okrywowa', label: 'Roślina okrywowa', count: 0 }
  ],

  // Opcje dla stref mrozoodporności
  hardiness: [
    { id: '5A', label: '5A (-28,9°C do -26,1°C)', count: 0 },
    { id: '5B', label: '5B (-26,1°C do -23,3°C)', count: 0 },
    { id: '6A', label: '6A (-23,3°C do -20,6°C)', count: 0 },
    { id: '6B', label: '6B (-20,6°C do -17,8°C)', count: 0 },
    { id: '7A', label: '7A (-17,8°C do -15,0°C)', count: 0 },
    { id: '7B', label: '7B (-15,0°C do -12,2°C)', count: 0 },
    { id: '8A', label: '8A (-12,2°C do -9,4°C)', count: 0 },
    { id: '8B', label: '8B (-9,4°C do -6,7°C)', count: 0 }
  ]
}

// Eksportujemy również pojedyncze opcje dla kompatybilności wstecznej
export const {
  category: categoryOptions,
  flowerColor: flowerColorOptions,
  leafColor: leafColorOptions,
  soilType: soilTypeOptions,
  sunExposure: sunExposureOptions,
  form: formOptions,
  growthRate: growthRateOptions,
  habit: habitOptions,
  leafType: leafTypeOptions,
  floweringSeason: floweringSeasonOptions,
  fruits: fruitsOptions,
  fruitingSeason: fruitingSeasonOptions,
  soilMoisture: soilMoistureOptions,
  soilPh: soilPhOptions,
  features: featuresOptions,
  gardenTypes: gardenTypesOptions,
  usage: usageOptions,
  hardiness: hardinessZoneOptions
} = plantOptions
